module.exports = __webpack_public_path__ + "static/media/ic_social_instagram_filled.01bae6c0.svg";